export default __webpack_public_path__ + "amz_logo_white_small.20db8672.png";